import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../core/services/user.service';
import { HelpFormDTO } from '../../core/models/helpform.model';
import { LoaderService } from '../../core/loader.service';

@Component({
  selector: 'app-help-bot',
  templateUrl: './help-bot.component.html',
  styleUrls: ['./help-bot.component.scss'],
})
export class HelpBotComponent implements OnInit {
  isModalOpen = false;
  isSuccessOpen = false;
  helpRequest: HelpFormDTO = new HelpFormDTO();

  // Custom validation states
  fullNameError = false;
  emailError = false;
  phoneError = false;
  issueError = false;

  // Dragging state to prevent click after drag
  isDragging = false;

  constructor(
    private userService: UserService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  onDragStarted(): void {
    this.isDragging = true;
  }

  onDragEnded(): void {
    // Delay resetting isDragging to ensure the click event is swallowed
    setTimeout(() => {
      this.isDragging = false;
    }, 50);
  }

  openHelpModal(event?: Event): void {
    if (this.isDragging) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    this.isModalOpen = true;
    this.isSuccessOpen = false;
    this.resetForm();
    this.cdr.detectChanges();
  }

  closeHelpModal(): void {
    this.isModalOpen = false;
    this.resetForm();
  }

  closeSuccessModal(): void {
    this.isSuccessOpen = false;
  }

  resetForm(): void {
    this.helpRequest = new HelpFormDTO();
    this.fullNameError = false;
    this.emailError = false;
    this.phoneError = false;
    this.issueError = false;
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  }

  validatePhone(phone: string): boolean {
    if (!phone || phone.trim() === '') {
      return true;
    }

    let digits = phone.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.substring(1);
    }

    return digits.length === 10;
  }

  onSubmit(form: NgForm): void {
    // Validate required fields
    this.fullNameError =
      !this.helpRequest.fullName || this.helpRequest.fullName.trim() === '';
    this.emailError =
      !this.helpRequest.email || !this.validateEmail(this.helpRequest.email);
    this.phoneError = !this.validatePhone(this.helpRequest.phone);
    this.issueError =
      !this.helpRequest.issueDescription ||
      this.helpRequest.issueDescription.trim() === '';

    if (
      this.fullNameError ||
      this.emailError ||
      this.phoneError ||
      this.issueError
    ) {
      return;
    }

    this.loaderService.show();

    this.userService.submitHelpForm(this.helpRequest).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res && res.success === 0) {
          // Success
          this.isModalOpen = false;
          this.isSuccessOpen = true;
        } else {
          // You might want to show an error message if the API fails
          alert(res?.message || 'Something went wrong, please try again.');
        }
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Error submitting help request:', err);
        alert('An error occurred. Please try again.');
      },
    });
  }
}
